import doesAttestationExist from '@sdk/timeClock/utils/doesAttestationExist';
import { TimesheetProjection } from '@sdk/timesheets/types/TimesheetProjection';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { TimesheetEntry, TimesheetEntryType } from '@sdk/timesheets/types/TimesheetEntry';
import getLatestTimesheetEntry from '@sdk/timesheets/helpers/getLatestTimesheetEntry';
import { EMPLOYEE_ACTIONS } from '@sdk/timesheets/consts';

type Props = {
  timesheetProjections: Pick<TimesheetProjection, 'breakAttestations'>[];
  timesheetStatus: TimesheetStatus;
  timesheetEntries: TimesheetEntry[];
};

export const shouldDisplayAttestations = ({
  timesheetProjections,
  timesheetStatus,
  timesheetEntries,
}: Props) => {
  if (!doesAttestationExist(timesheetProjections)) {
    return false;
  }

  if (
    timesheetStatus === TimesheetStatus.pendingConsent ||
    timesheetStatus === TimesheetStatus.approved
  ) {
    // pendingConsent means we overriden any previous attestations - so we hide them as irrelevant
    // approved means we acknowledged all the
    return false;
  }

  const latestEntry = getLatestTimesheetEntry(timesheetEntries);
  const { type: latestEntryType } = latestEntry;

  if (latestEntryType === TimesheetEntryType.markConsentDenied) {
    // If employee denied the changes, than we restore displaying attestations.
    // This means "employee's version" remains the source of truth.
    return true;
  }

  // if employee clockedIn, clockedOut etc. it means "his version" is trueth now
  // that means we need to display attestations
  return EMPLOYEE_ACTIONS.includes(latestEntryType);
};
